import React, { useState, useEffect } from 'react';
import { Page, Tabs } from '@shopify/polaris';
import Faqs from './Faqs';
import { authenticatedFetch } from '../utils/api';
import AgentDashboard from './AgentDashboard';
import { plans, getResolvedFeatures } from '../plans';
import { config, APP_HANDLE, SUPPORT_EMAIL, DEFAULT_PLAN_NAMES, PLAN_FEATURES } from '../constants';

export default function Admin({ storeId }) {
  const [selected, setSelected] = useState(0);
  const [features, setFeatures] = useState([]);


  useEffect(() => {
    async function fetchPlan() {
      try {
        const res = await fetch(`${config.API_BASE}/current-plan?shop=${storeId}`);
        const data = await res.json();
        setFeatures(getResolvedFeatures(data?.plan || 'Free', plans));
      } catch {
        setFeatures(getResolvedFeatures('Free', plans));
      }
    }
    if (storeId) fetchPlan();
  }, [storeId]);

  const tabs = [
    {
      id: 'knowledge',
      content: 'FAQs',
      panelID: 'knowledge-panel',
    },
  ];

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>
      <Page>
        <Tabs
          tabs={tabs}
          selected={selected}
          onSelect={setSelected}
        >
          {selected === 0 && <Faqs storeId={storeId} />}
        </Tabs>
      </Page>
    </div>
  );
}
